// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2287":"UserMatchHistoryPage","4756":"PrivacyPolicyPage","7836":"AdminManageUserPage","7857":"MapsPage","8210":"ViewTeamPage","8218":"TOSPage"}[chunkId] + "." + {"2287":"6e43854c","4756":"7a6f5f0b","7836":"d8b6adb0","7857":"5501bc76","8210":"6e43854c","8218":"fceb3466"}[chunkId] + ".chunk.css";
};